import React from 'react';
import ReactDOM from 'react-dom/client';

import SiteSearch from './SiteSearch';

const root = ReactDOM.createRoot(document.getElementById('site_search'));

root.render(
  <React.StrictMode>
    <SiteSearch />
  </React.StrictMode>
);
